export const constants = {
  MFE_NOTIFICATIONS_NAME: 'notifications',
  MFE_NOTIFICATIONS_EXPOSED_PATH: './NotificationsApp',
  MFE_NOTIFICATIONS_MOBILE_EXPOSED_PATH: './NotificationsMobile',
  MFE_NOTIFICATIONS_CONTROL_TOWER_WIDGET_EXPOSED_PATH: './ControlTowerWidget',
  MFE_NOTIFICATIONS_CONTROL_TOWER_GLOBAL_PANEL_EXPOSED_PATH: './ControlTowerGlobalPanel',
};
